(function () {
  const pnzHandle = '/products/aoi-living-german-wood-wax-oil-maintenance-kit';

  function updateCards(root = document) {
    root.querySelectorAll('a[href*="/products/aoi-living-"]').forEach((link) => {
      const gallery = link.closest('.card-gallery');
      if (!gallery) return;
      gallery.classList.add('card-gallery--aoi-living-runtime');

      if (!link.getAttribute('href').includes(pnzHandle) || !window.aoiPnzMainImage) return;
      const firstImage = gallery.querySelector('.product-media-container img');
      if (firstImage && firstImage.src !== window.aoiPnzMainImage) {
        firstImage.src = window.aoiPnzMainImage;
        firstImage.removeAttribute('srcset');
        firstImage.removeAttribute('sizes');
        firstImage.alt = 'PNZ Wood Wax Oil Maintenance Kit';
      }
    });
  }

  function init() {
    updateCards();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) updateCards(node.matches?.('a[href*="/products/aoi-living-"]') ? node.parentElement : node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
